import { MOBILE_HEADER_HEIGHT, SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import styled from 'styled-components'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'

export const AiLibContainer = styled.div`
  padding: 32px 16px 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    overflow-y: auto;
    height: calc(100dvh - ${MOBILE_HEADER_HEIGHT}px);
  }
`

export const AILibContentWrapper = styled.div<{ $isActive: boolean }>`
  display: ${({ $isActive }) => ($isActive ? 'flex' : 'none')};
  flex-direction: column;
  height: 100%;
  width: 100%;
  flex: 1;
  padding-right: 14px;
  box-sizing: content-box;
  overflow-y: auto;
  overflow-x: hidden;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    padding-right: 0;
  }

  ${customizeVerticalScrollbarThumbMixin()}
`
